import { z } from 'zod';
import { LABELS } from '../../constants';
import { isValidDate, requiredFieldError, requiredString, validateDateOfBirth, validateMobile } from '../../helper';
import { ApplicantStatus, ApplicantType } from '../../types';
import { address } from './address';

const { FIRST_NAME, LAST_NAME, DATE_OF_BIRTH, EMAIL } = LABELS;

export const applicantName = z.object({
  firstName: requiredString(FIRST_NAME),
  middleName: z.string().trim().nullish(),
  lastName: requiredString(LAST_NAME),
});

export const applicantContact = z.object({
  address: address,
  email: requiredString(EMAIL).email().optional(),
  phone: validateMobile.optional(),
});

export const applicantMetadata = z.object({
  id: requiredString(),
  type: z.nativeEnum(ApplicantType),
  status: z.nativeEnum(ApplicantStatus),
  secureCode: z.string().optional(),
  dateOfBirth: z.union([
    z
      .date({
        required_error: requiredFieldError(DATE_OF_BIRTH),
        invalid_type_error: requiredFieldError(DATE_OF_BIRTH),
      })
      .refine(value => {
        return validateDateOfBirth(value);
      }, 'Enter a valid date of birth'),
    z.string().refine(value => isValidDate(value), 'Enter a valid date of birth'),
  ]),
  operatorId: z.string().optional(),
});

export const baseResidentialApplicant = applicantName.merge(applicantContact).merge(applicantMetadata);

export const baseBusinessApplicant = applicantName.merge(applicantContact.pick({ email: true, phone: true })).merge(
  applicantMetadata.pick({
    id: true,
    type: true,
    status: true,
    secureCode: true,
  }),
);
